import React, {Component} from 'react';
import { Grid, Row, Col, Dropdown } from 'react-bootstrap';
import { connect } from "react-redux";
import Greeting from './Greeting';

class CustomToggle extends Component {
  render() {
    return (
      <a id="dashmenu" className="disabled">
        {this.props.children}
      </a>
    );
  }
}

class CustomMenu extends Component {
  render() {
    return (
        <ul className="dropdown-menu hidden"></ul>
    );
  }
}

class MockMenu extends Component {
  render() {
    return (
      <Grid>
        <div className="dashboard">
          <Row id="exflowmenu">
            <Col xs={12}>
              <Dropdown id="dashmenu" block vertical>
                <CustomToggle bsRole="toggle"><Greeting /></CustomToggle>
                <CustomMenu bsRole="menu"></CustomMenu>
              </Dropdown>
            </Col>
            <img className="style-svg smalllogo pull-right" src="/images/logo/logo-small.svg" height="30px" alt="MoneyKey Small Logo"/>
          </Row>
        </div>
        <div className="dashheader">
          {this.props.pagename} {this.props.approvedamt>0 && <p className="animated tada" style={{float:'right',fontSize:'16px',fontWeight:'bold'}}>${this.props.loanamt}</p>}
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
    pagename: state.FormReducer.pagename,
    approvedamt: state.FormReducer.approvedamt,
    loanamt: state.FormReducer.loanamt,
});

export default connect(mapStateToProps)(MockMenu);



// WEBPACK FOOTER //
// ./src/components/partials/MockMenu.js